export const verificationFirstNullKey = (data: any) => {
  return Object.keys(data).find((key) => {
    if (key === 'fourth_tier') {
      return data[key].pdf_file_paths.includes(null)
    }
    return Object.values(data[key]).includes(null);
  });
}